var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 10.7501V16.4167M15.9998 22.0834H16.014M14.0382 3.51336L2.38626 23.6394C1.73997 24.7557 1.41683 25.3139 1.46459 25.772C1.50624 26.1716 1.71559 26.5346 2.04051 26.7709C2.41303 27.0417 3.05799 27.0417 4.3479 27.0417H27.6517C28.9416 27.0417 29.5866 27.0417 29.9591 26.7709C30.284 26.5346 30.4934 26.1716 30.535 25.772C30.5828 25.3139 30.2597 24.7557 29.6134 23.6394L17.9614 3.51335C17.3175 2.40104 16.9955 1.84488 16.5754 1.65809C16.209 1.49515 15.7907 1.49515 15.4242 1.65809C15.0041 1.84488 14.6822 2.40104 14.0382 3.51336Z",
    stroke: "#667085",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.ac011d6e0939d1459092f1b598451438.svg";
export { ForwardRef as ReactComponent };